import { Grid, Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AutocompleteField } from '@roc/ui';
import { observer } from 'mobx-react';
import { useState } from 'react';

const useStyles = makeStyles(theme => ({
  content: {
    fontWeight: 'bold',
    fontSize: '15px'
  },
  label: {
    fontSize: '13px',
  },
  labelBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const ToolbarInfoItem = observer(({ value, label }) => {
  const classes = useStyles();

  return (
    <Box justifyContent="center" className={`${classes.labelBox}`}>
      <Typography variant="body2" component="p" className={classes.content}>
        {value}
      </Typography>
      <Typography variant="caption" color="textSecondary" component="p" className={classes.label}>
        {label}
      </Typography>
    </Box>
  )
});
